import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();

var _showModal = false;
var _message;

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {
        case ActionTypes.SHOW_MODAL_ERROR:
            _showModal = true;
            _message = action.message;
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        case ActionTypes.HIDE_MODAL_ERROR:
            _showModal = false;
            _message = "";
            _events.trigger(ActionTypes.CHANGE_EVENT);
            break;

        default:
        //no op
    }
});//end of dispatch token

//public api
export const modalErrorStore = {
    dispatchToken,
    subscribe: _events.on,
    unsubscribe: _events.off,
    showModal: function () {
        return _showModal;
    },
    message: function () {
        return _message;
    }
};
